import { useTranslation } from "react-i18next";
import CostRefundReviewModal from "features/hr/costRefund/components/CostRefundReviewModal";
import { canBeAccepted, canBeCorrected, canBeDeleted, canBeMarkedAsIncomplete, getBackgroundStyle, getStatusIcon, getStatusLabel } from "features/hr/costRefund/components/CostRefundLogic";
import Modal from "components/commons/Modal";
import { NavLink } from "react-router-dom";
import UserImage from "components/commons/UserImage";
import { useSelector } from "react-redux";
import { selectCompanyGuid } from "features/auth/authSlice";
import { Galleria } from "primereact/galleria";

export default function CostRefundView({
    refund,
    administrable = false,
    onAccept,
    onDelete
}) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    const companyGuid = useSelector(selectCompanyGuid)

    const apiUrl = process.env.REACT_APP_API_URL

    let startDate = new Date(refund.startDate * 1000)
    let endDate = new Date(refund.endDate * 1000)

    let days = Math.round((endDate.getTime() - startDate.getTime()) / (1000 * 3600 * 24) + 1);

    function hasDistance() {
        return refund.distance != null && refund.distance > 0
    }

    function hasExpenses() {
        return refund.totalExpense > 0
    }

    function hasAttachments() {
        return refund.attachments.length > 0
    }


    return (<>

        <div className={`card text-white h-100 bg-dark bg-opacity-25`}>
            <div className={`card-header ${getBackgroundStyle(refund)}`}>
                <div>
                    <CostRefundStatus refund={refund} />
                </div>
                <div className='row my-3'>
                    <div className='col-6'>

                        <h3>{refund.title}</h3>
                    </div>
                </div>

                {
                    refund.user &&
                    <div className='row my-3'>
                        <div className='col-6'>
                            {/* <img className="rounded-circle me-2" width="48px" src={`https://ui-avatars.com/api/?name=${refund.user.displayName.replace(" ", "+")}&background=random`} /> */}
                            <UserImage guid={refund.user.guid} />
                            <span className='ms-2'>{refund.user ? refund.user.displayName : "La mia nota spesa"}</span>

                        </div>
                    </div>
                }

            </div>
            <div className="card-body bg-black bg-opacity-10">

                <div className='row p-2'>
                    <div className="col-auto">
                        <input className="form-check-input" type="checkbox" id="kmMode" name="kmMode" checked={refund.isKmMode} /> <label htmlFor="kmMode"> {t("absenceReport:entity.costRefund.type.distance")}</label>
                    </div>
                    <div className="col-auto">
                        <input className="form-check-input" type="checkbox" id="forfaitMode" name="forfaitMode" checked={refund.isForfaitMode} /> <label htmlFor="forfaitMode"> {t("absenceReport:entity.costRefund.type.forfait")}</label>
                    </div>
                    <div className="col-auto">
                        <input className="form-check-input" type="checkbox" id="analyticMode" name="analyticMode" checked={refund.isAnalyticMode} /> <label htmlFor="analyticMode"> {t("absenceReport:entity.costRefund.type.analytic")}</label>
                    </div>

                </div>

                <div className='row p-2'>
                    <div className="col-auto">
                        <h5><i className="fa-solid fa-calendar-days text-muted"></i> {days} {t("global:unit.days", { count: days })}</h5>
                    </div>
                    <div className="col-auto">
                        <small className='text-muted ms-2'>
                            <>{t("particles.from")} {new Date(refund.startDate * 1000).toLocaleDateString()} {t("particles.to")} {new Date(refund.endDate * 1000).toLocaleDateString()}</>
                        </small>
                    </div>
                </div>

                {
                    hasDistance() &&
                    <div className='row p-2'>
                        <div className="col"><h5><i className={`fa-solid fa-road text-muted `}></i> {refund.distance} km</h5></div>

                    </div>
                }

                {
                    hasExpenses() &&
                    <>
                        <div className='mt-3 p-2 bg-black bg-opacity-25'>
                            {
                                refund.expenseItems.map(item => {

                                    return <div className="row">
                                        <div className="col text-muted">
                                            {item.name}
                                        </div>
                                        <div className="col text-end text-muted">
                                            {item.import.toFixed(2)}
                                        </div>
                                    </div>
                                })
                            }
                            <hr />
                            <div className="row">
                                <div className="col">
                                    <b>{t("unit.total")}</b>
                                </div>
                                <div className="col text-end">
                                    <h4><span className='text-muted'>€</span> {refund.totalExpense.toFixed(2)}</h4>
                                </div>
                            </div>
                        </div>
                    </>
                }

                {
                    hasAttachments() &&

                    // refund.attachments.map(fileName => {
                    //     return <img src={`${apiUrl}/file?file=${fileName}`} width="300" />
                    // })



                    <div className="mt-3">
                        < Galleria
                            value={refund.attachments.map(fileName => {
                                return `${apiUrl}/file?file=${fileName}`
                            })}
                            responsiveOptions={[
                                {
                                    breakpoint: '991px',
                                    numVisible: 4
                                },
                                {
                                    breakpoint: '767px',
                                    numVisible: 3
                                },
                                {
                                    breakpoint: '575px',
                                    numVisible: 1
                                }
                            ]}
                            numVisible={5}
                            style={{ maxWidth: '640px' }}
                            item={(item) => {
                                return <img src={item} alt={item.alt} style={{ width: '100%' }} />
                            }}
                            thumbnail={(item) => {
                                return <img src={item} alt={item.alt} style={{ width: '100px' }} />
                            }}
                            showItemNavigators
                        />
                    </div>


                }

            </div>
            <div className="card-footer">
                {
                    administrable && canBeDeleted(refund) &&
                    <Modal
                        modalId={"deletetModal" + refund.guid}
                        buttonClass="btn-outline-danger mx-2"
                        buttonLabel={t("action.delete")}
                        buttonIcon={<i className="fa-solid fa-trash"></i>}
                        body={t("absenceReport:helper.confirm_delete")}
                        onConfirm={() => onDelete(refund.guid)}
                    />
                }
                {
                    administrable && canBeMarkedAsIncomplete(refund) &&
                    <CostRefundReviewModal refundGuid={refund.guid} />
                }
                {
                    !administrable && canBeCorrected(refund) &&
                    <NavLink to={{ pathname: "/dashboard/costRefunds/my/edit" }} state={{ costRefund: refund }} className="btn btn-warning"><i className="fa-solid fa-triangle-exclamation fa-beat"></i> {t("action.adjust")}</NavLink>
                }
                {
                    administrable && canBeAccepted(refund) &&
                    <Modal
                        modalId={"acceptModal" + refund.guid}
                        buttonClass="btn-success mx-2"
                        buttonLabel={t("action.accept")}
                        buttonIcon={<i className="fa-solid fa-circle-check fa-beat"></i>}
                        body={t("absenceReport:helper.confirm_accept")}
                        onConfirm={() => onAccept(refund.guid)}
                    />
                }
            </div>
        </div>
    </>)
}

function CostRefundStatus({ refund }) {

    const [t, i18n] = useTranslation(["global", "absenceReport"])

    function getColor() {
        switch (refund.status) {
            case "SENT": return "bg-dark"
            case "ACCEPTED": return "bg-success"
            case "INCOMPLETE": return "bg-warning bg-opacity-75"
            case "UPDATED": return "bg-primary"
            case "CANCELED": return "bg-dark"
            case "DELETED": return "bg-danger"
            default: return "bg-dark"
        }
    }

    return <div className="row">
        <div className="col">
            <div className={`badge rounded-pill  ${getColor()}`}><h6 className="m-1">{getStatusIcon(refund)} {getStatusLabel(refund, t).toUpperCase()} </h6> </div> <small className="px-2"> {new Date(refund.lastEditAt).toLocaleString([], { dateStyle: "short", timeStyle: 'short' })}</small>
        </div>
        <div className="col text-end">
            <small className="text-muted">{t("property.created_at")} {new Date(refund.createdDate).toLocaleString([], { dateStyle: "short", timeStyle: 'short' })}</small>
        </div>

    </div>

}
